const segmentPixel = () => {
  'ngInject'

  const baseUrl = 'https://api.segment.io/v1/pixel/track?data='

  const getPixelUrl = (event) => {
    const segmentKey = CONFIG.SEGMENT_KEY
    const payload = {
      'writeKey': segmentKey,
      'event': event
    }
    const encodedPayload = btoa(JSON.stringify(payload))
    return baseUrl + encodedPayload
  }

  return {
    getPixelUrl
  }
}

export default segmentPixel
